
CustomTC.define('text!modules/recast/htmls/recast.html',[],function () { return '<div class="tcNewreCastWrapper hide767">\r\n\t<div id="tcLangReCastDesc" class="tcNewreCastContainer"> reCasting will post this<br />\r\n\tTouchCast to your channel </div>\r\n\t<div class="tcNewreCastFooter"> <span id="reCastThisTC">reCast This TouchCast</span> </div>\r\n</div>';});

